import { GuestRegistrationComponent } from './guest-registration/guest-registration.component';
import {
    Injectable,
    NgModule
} from '@angular/core';
import {
    CommonModule
} from '@angular/common';
import { UserItemComponent } from './user-item/user-item';
import { UserAvatarComponent } from './user-avatar/user-avatar';
import { UserTrapezoidComponent } from './user-trapezoid/user-trapezoid.component';
import { CertificatePreviewComponent } from './certificate-preview/certificate-preview/certificate-preview.component';
import { IonicModule } from '@ionic/angular';
import { MultiSelectCheckboxesComponent } from './multi-select-checkboxes/multi-select-checkboxes.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserNameComponent } from './user-name/user-name.component';
import { CircleProgressComponent } from './circle-progress/circle-progress/circle-progress.component';
import { ImessageComponent } from './imessage/imessage/imessage.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { LinearProgressComponent } from './circle-progress/linear-progress/linear-progress.component';
import { SvgPlayingCardComponent } from './svg-playing-card/svg-playing-card.component';
import { ExpandableComponent } from './expandable/expandable.component';
import { TableCountdownComponent } from './table-countdown/table-countdown.component';
import { GameBoxComponent } from './game-box/game-box.component';
import { TabBoxComponent } from './tab-box/tab-box.component';
import { PlayingCardComponent } from './playing-card/playing-card.component';
import { PlayerClockComponent } from './player-clock/player-clock.component';
import { CurrencySelectorComponent } from './currency-selector/currency-selector.component';
import { ContainerTitleComponent } from './container-title/container-title.component';
import { TitleBarComponent } from './title-bar/title-bar.component';
import { NotificationsToggleComponent } from './notifications-toggle/notifications-toggle.component';
import { SopoBadgeComponent } from './sopo-badge/sopo-badge.component';
import { SopoListItemComponent } from './sopo-list-item/sopo-list-item.component';
import { SopoLoaderDotsComponent } from './sopo-loader-dots/sopo-loader-dots.component';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { NftDetailsComponent } from './nft-details/nft-details.component';
import { SopoTransitionComponent } from './sopo-transition/sopo-transition.component';
import { DialogAlertComponent } from './dialog-alert/dialog-alert.component';
import { FeltAndBackgroundSelectorComponent } from './felt-and-background-selector/felt-and-background-selector.component';
import { LoginAndRegistrationComponent } from './login-and-registration/login-and-registration.component';
import { SwiperModule } from 'swiper/angular';
import { OverlayContainer } from '@angular/cdk/overlay';
import { ClubChatBoxComponent } from 'src/app/club/components/club-chat-box/club-chat-box.component';
import { MessageBubbleComponent } from 'src/app/club/components/message-bubble/message-bubble.component';
import { MomentModule } from 'ngx-moment';
import { HeaderComponent } from 'src/app/shared/components/header/header.component';
import { AvatarsComponent } from 'src/app/account/pages/profile/component/the-rail/profile-game-settings/avatars/avatars.component';
import { BackgroundComponent } from 'src/app/account/pages/profile/component/the-rail/profile-game-settings/background/background.component';
import { BetButtonsComponent } from 'src/app/account/pages/profile/component/the-rail/profile-game-settings/bet-buttons/bet-buttons.component';
import { CardsComponent } from 'src/app/account/pages/profile/component/the-rail/profile-game-settings/cards/cards.component';
import { FeltComponent } from 'src/app/account/pages/profile/component/the-rail/profile-game-settings/felt/felt.component';
import { TableComponent } from 'src/app/account/pages/profile/component/the-rail/profile-game-settings/table/table.component';
import { MyWalletComponent } from 'src/app/account/pages/profile/component/the-rail/profile-game-settings/my-wallet/my-wallet.component';
import { NftSelectorComponent } from 'src/app/account/pages/profile/component/the-rail/profile-game-settings/nft-selector/nft-selector.component';
import { NftsComponent } from 'src/app/account/pages/profile/component/the-rail/profile-game-settings/nfts/nfts.component';
import { AppleDeleteConfirmationComponent } from 'src/app/account/pages/profile/component/the-rail/avatar-info/apple-delete-confirmation/apple-delete-confirmation.component';
import { AvatarInfoNftComponent } from 'src/app/account/pages/profile/component/the-rail/avatar-info/avatar-info-nft/avatar-info-nft.component';
import { ChangeNameComponent } from 'src/app/account/pages/profile/component/the-rail/avatar-info/change-name/change-name.component';
import { SharedPipesModule } from '../pipes/shared.pipes.module';
import { SettingOptionsComponet } from 'src/app/account/pages/profile/component/new-profile/setting-options/setting-options.component';
import { MoreInformationComponet } from 'src/app/account/pages/profile/component/new-profile/more-information/more-information.component';
import { SopoSelectButtonComponent } from './sopo-select-button/sopo-select-button.component';
import { ShopProductComponent } from 'src/app/shop/component/product/product.component';
import { SweepsbucksMenuComponent } from './sweepsbucks-menu/sweepsbucks-menu';
import { XpBarComponent } from './xp-bar/xp-bar.component';
import { DailyMissionsComponent } from './daily-missions/daily-missions.component';
import { GameSelectionComponent } from './game-selection/game-selection.component';
import { GameSelectionContentComponent } from './game-selection-popup/game-selection-content.component';
import { ShopProductSliderComponent } from './shop-product-slider/shop-product-slider.component';
import { CommunityFeltsComponent } from 'src/app/shared/components/community-felts/community-felts.component';
import { LocationAlertComponent } from './location-alert/location-alert.component';
import { AbstractClubJoinPopup } from './abstract-club-join-popup/abstract-club-join-popup.component';
import { AbstractLoginComponent } from './abstract-login/abstract-login.component';
import { BitcoinNotificationComponent } from './bitcoin-notification/bitcoin-notification.component';
import { PointsProgressBarComponent } from './points-progress-bar/points-progress-bar.component';
import { PlayerInfoComponent } from './player-info/player-info.component';
import { SopoTooltipComponent } from './sopoTooltip/sopo-tooltip/sopo-tooltip.component';
import { SopoTooltipDirective } from '../directives/sopoTooltip/sopo-tooltip.directive';
import { TabSelectorComponent } from './tab-selector/tab-selector.component';
import { WaitingListComponent } from './waiting-list/waiting-list.component';
import { GameTablesComponent } from './game-tables/game-tables.component';
import { TableViewSelectorComponent } from './table-view-selector/table-view-selector.component';
import { WalletContainerComponent } from './wallet-container/wallet-container.component';
import { QrLoginComponent } from './qr-login/qr-login.component';
import { KYCRequiredDialogComponent } from './kyc-required-dialog/kyc-required-dialog.component';
import { ProfileSetupComponent } from './profile-setup/profile-setup.component';

@Injectable()
export class SharedOverlayContainer extends OverlayContainer {
    protected _containerElementInShared: HTMLElement;

    protected _createContainer(): void {
        const container: HTMLDivElement = document.createElement("div");
        container.classList.add("shared-overlay-container");
        container.style.zIndex = '2001';

        const element: Element | null = document.getElementById("sopo-app");
        if (element !== null) {
            element.appendChild(container);
            this._containerElementInShared = container;
        }
    }
    getContainerElement(): HTMLElement {
        if (
        !(
            this._containerElementInShared &&
            document.body.contains(this._containerElementInShared)
        )
        ) {
        this._createContainer();
        }

        return this._containerElementInShared;
    }
}
@NgModule({
    declarations: [
        UserItemComponent,
        UserAvatarComponent,
        UserNameComponent,
        UserTrapezoidComponent,
        MultiSelectCheckboxesComponent,
        CircleProgressComponent,
        LinearProgressComponent,
        ImessageComponent,
        CertificatePreviewComponent,
        SvgPlayingCardComponent,
        ExpandableComponent,
        TableCountdownComponent,
        TabBoxComponent,
        PlayingCardComponent,
        PlayerClockComponent,
        GameBoxComponent,
        CurrencySelectorComponent,
        ContainerTitleComponent,
        TitleBarComponent,
        NotificationsToggleComponent,
        SopoListItemComponent,
        SopoBadgeComponent,
        SopoLoaderDotsComponent,
        VideoPlayerComponent,
        NftDetailsComponent,
        SopoTransitionComponent,
        DialogAlertComponent,
        FeltAndBackgroundSelectorComponent,
        LoginAndRegistrationComponent,
        GuestRegistrationComponent,
        ClubChatBoxComponent,
        MessageBubbleComponent,
        HeaderComponent,
        AvatarsComponent,
        BackgroundComponent,
        CardsComponent,
        FeltComponent,
        TableComponent,
        BetButtonsComponent,
        NftsComponent,
        MyWalletComponent,
        NftSelectorComponent,
        ChangeNameComponent,
        AvatarInfoNftComponent,
        AppleDeleteConfirmationComponent,
        SettingOptionsComponet,
        MoreInformationComponet,
        SopoSelectButtonComponent,
        ShopProductComponent,
        SweepsbucksMenuComponent,
        XpBarComponent,
        DailyMissionsComponent,
        GameSelectionComponent,
        GameSelectionContentComponent,
        ShopProductSliderComponent,
        CommunityFeltsComponent,
        LocationAlertComponent,
        AbstractClubJoinPopup,
        AbstractLoginComponent,
        BitcoinNotificationComponent,
        PointsProgressBarComponent,
        TabSelectorComponent,
        WaitingListComponent,
        GameTablesComponent,
        TableViewSelectorComponent,
        WalletContainerComponent,
        KYCRequiredDialogComponent,
        ProfileSetupComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        IonicModule,
        PdfViewerModule,
        SwiperModule,
        FormsModule,
        MomentModule,
        SharedPipesModule,
        PlayerInfoComponent,
        SopoTooltipComponent,
        SopoTooltipDirective,
        QrLoginComponent,
    ],
    providers: [
        { provide: OverlayContainer, useClass: SharedOverlayContainer }
    ],
    exports: [
        UserItemComponent,
        UserAvatarComponent,
        UserNameComponent,
        UserTrapezoidComponent,
        MultiSelectCheckboxesComponent,
        CircleProgressComponent,
        CertificatePreviewComponent,
        LinearProgressComponent,
        SvgPlayingCardComponent,
        ExpandableComponent,
        TableCountdownComponent,
        TabBoxComponent,
        PlayingCardComponent,
        PlayerClockComponent,
        GameBoxComponent,
        CurrencySelectorComponent,
        ContainerTitleComponent,
        TitleBarComponent,
        NotificationsToggleComponent,
        TitleBarComponent,
        SopoListItemComponent,
        SopoBadgeComponent,
        SopoLoaderDotsComponent,
        VideoPlayerComponent,
        NftDetailsComponent,
        FeltAndBackgroundSelectorComponent,
        LoginAndRegistrationComponent,
        GuestRegistrationComponent,
        ClubChatBoxComponent,
        MessageBubbleComponent,
        HeaderComponent,
        AvatarsComponent,
        BackgroundComponent,
        CardsComponent,
        FeltComponent,
        TableComponent,
        BetButtonsComponent,
        NftsComponent,
        MyWalletComponent,
        NftSelectorComponent,
        ChangeNameComponent,
        AvatarInfoNftComponent,
        AppleDeleteConfirmationComponent,
        SettingOptionsComponet,
        MoreInformationComponet,
        SopoSelectButtonComponent,
        ShopProductComponent,
        SweepsbucksMenuComponent,
        XpBarComponent,
        DailyMissionsComponent,
        GameSelectionComponent,
        GameSelectionContentComponent,
        ShopProductSliderComponent,
        CommunityFeltsComponent,
        AbstractClubJoinPopup,
        AbstractLoginComponent,
        BitcoinNotificationComponent,
        PointsProgressBarComponent,
        TabSelectorComponent,
        WaitingListComponent,
        GameTablesComponent,
        TableViewSelectorComponent,
        PlayerInfoComponent,
        SopoTooltipComponent,
        WalletContainerComponent,
        ProfileSetupComponent,
    ],
})
export class SharedComponentsModule {}
